import React from 'react';
import OtcDate from 'ui-components/react/OtcDate';

export default function DateField(prop) {
  return <OtcDate {...prop}/>
}


// WEBPACK FOOTER //
// ./src/components/common/DateField/DateField.jsx